import {Component, DestroyRef, inject, OnInit} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {DocumentDetailActivitiesDatasource} from './document-detail-activities.datasource';
import {CirculationSearchService, CirculationTableComponent, CirculationView, DocumentDetailService} from '|shared';
import {LabelComponent} from '@icz/angular-essentials';


@Component({
  selector: 'icz-document-detail-activities',
  templateUrl: './document-detail-activities.component.html',
  styleUrls: ['./document-detail-activities.component.scss'],
  imports: [CirculationTableComponent, LabelComponent]
})
export class DocumentDetailActivitiesComponent implements OnInit {

  searchService = inject(CirculationSearchService);
  documentDetailService = inject(DocumentDetailService);
  private destroyRef = inject(DestroyRef);

  dataSource!: DocumentDetailActivitiesDatasource;

  readonly CirculationView = CirculationView;

  ngOnInit() {
    this.documentDetailService.objectId$.pipe(
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(documentId => {
      if (!isNil(documentId)) {
        if (!this.dataSource) {
          this.dataSource = new DocumentDetailActivitiesDatasource(this.searchService, documentId);
        }
        else {
          this.dataSource.reload(true);
        }
      }
    });
  }

}
